import { Observable, BehaviorSubject, observable } from 'rxjs';
import { REST_SERVICES } from './settings';
import { ZeroService } from './zero/zero.service';
import { Injectable } from '@angular/core';

@Injectable()
export class AlertasService {
    public totalAlertas = new BehaviorSubject<number>(0);
    
    constructor(private zeroService: ZeroService) {
        
    }

    getAlertas():Observable<number>{
      return this.totalAlertas.asObservable(); 
    }

    consultarTotalAlertas() {
        let scope = this;
        scope.zeroService.request({
          isSingleResponse: false,
          uri: REST_SERVICES.BUSQUEDA_TOTAL_ALERTAS,
          method: "GET",
          showInfo: true,
          ok: (response) => {
            if (response.responsecode == "0") { 
              scope.totalAlertas.next(response.response.totalAlerts);
            } else {
              scope.totalAlertas.next(0); 
            }
          },
          error: (response) => {
            scope.totalAlertas.next(0); 
          }
        });
      }
}